

export default () => {
  return {
    componentData: {},
    chatId: null,
  }
}
